import _extends from '@babel/runtime/helpers/extends';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default from 'react';
import { Popper } from 'react-popper';
import './Tooltip.scss.js';
import { createPortal } from 'react-dom';

var getOffsetPadding = function getOffsetPadding(offsetPopper, placement) {
  var offset = offsetPopper[1] || 8;
  var offsetPadding = {
    'auto-end': {},
    'auto-start': {},
    'auto': {},
    'left': {
      paddingRight: "".concat(offset, "px")
    },
    'left-end': {
      paddingRight: "".concat(offset, "px")
    },
    'left-start': {
      paddingRight: "".concat(offset, "px")
    },
    'right': {
      paddingLeft: "".concat(offset, "px")
    },
    'right-end': {
      paddingLeft: "".concat(offset, "px")
    },
    'right-start': {
      paddingLeft: "".concat(offset, "px")
    },
    'top': {
      paddingBottom: "".concat(offset, "px")
    },
    'top-end': {
      paddingBottom: "".concat(offset, "px")
    },
    'top-start': {
      paddingBottom: "".concat(offset, "px")
    },
    'bottom': {
      paddingTop: "".concat(offset, "px")
    },
    'bottom-start': {
      paddingTop: "".concat(offset, "px")
    },
    'bottom-end': {
      paddingTop: "".concat(offset, "px")
    }
  };
  return offsetPadding[placement] || {};
};

var TooltipContent = function TooltipContent(_a) {
  var children = _a.children,
      _a$position = _a.position,
      position = _a$position === void 0 ? 'top' : _a$position,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$background = _a.background,
      background = _a$background === void 0 ? 'white' : _a$background,
      _a$offset = _a.offset,
      offset = _a$offset === void 0 ? [0, 8] : _a$offset,
      hidePadding = _a.hidePadding,
      hide = _a.hide,
      props = __rest(_a, ["children", "position", "className", "background", "offset", "hidePadding", "hide"]);

  return /*#__PURE__*/createPortal( /*#__PURE__*/React__default.createElement(Popper, _extends({
    placement: position,
    modifiers: [{
      name: 'flip',
      options: {
        allowedAutoPlacements: ['right', 'left', 'top', 'bottom']
      }
    }]
  }, props, {
    "data-v-6e52f9c7": ""
  }), function (_ref) {
    var ref = _ref.ref,
        dropdownStyle = _ref.style,
        placement = _ref.placement,
        isReferenceHidden = _ref.isReferenceHidden;
    return /*#__PURE__*/React__default.createElement("div", {
      ref: ref,
      className: "rf-tooltip__content-wrapper",
      style: Object.assign(Object.assign(Object.assign({}, dropdownStyle), getOffsetPadding(offset, placement)), hide && isReferenceHidden ? {
        visibility: 'hidden',
        pointerEvents: 'none'
      } : {}),
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "rf-tooltip__content rf-tooltip__content--".concat(background, " ").concat(className),
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "rf-tooltip__inner ".concat(hidePadding ? 'rf-tooltip__inner--no-pudding' : ''),
      "data-v-6e52f9c7": ""
    }, children)));
  }), document.body);
};

export { TooltipContent as default };
